import {navItems} from '../UI/navigation/types.js'
import type {AppNavigation} from './types.js'
import t from '../../helpers/Languages.js'

interface CustomerNavigationOptions {
    reseller: {name?: string, settings?: {accountName?: string}}
    user: {name?: string, permissions: Record<string, boolean | undefined>}
    accounts: unknown[]
    pathname: string
    onClickHelp: () => void
    onClickSwitchAccount: () => void
    onClickLogout: () => void
    // Own details and password (#602), left out while logged in as a customer or carrier
    onClickDetails?: () => void
    onClickPassword?: () => void
}

/** The navigation of the customer portal (src/views/customer/Layout.js) for the permissions of the user */
export function customerNavigation(options: CustomerNavigationOptions): AppNavigation {
    const {reseller, user, accounts, pathname} = options

    return {
        items: navItems([
            (user.permissions.orders || user.permissions.ordersRead) && {key: 'ritten', icon: 'mdi mdi-format-list-bulleted', title: `Ritten ${reseller.settings?.accountName || reseller.name || ''}`, target: '/klant/ritten', active: pathname === '/klant/ritten'},
            user.permissions.parcels && {key: 'zendingen', icon: 'mdi mdi-package-variant-closed', title: 'Zendingen', target: '/klant/zendingen', active: pathname === '/klant/zendingen'}
        ]),
        endItems: [
            {key: 'help', icon: 'mdi mdi-help-circle', title: 'Help', onClick: options.onClickHelp},
            {key: 'instellingen', icon: 'mdi mdi-cog', title: 'Instellingen', target: '/klant/instellingen', active: pathname.indexOf('/klant/instellingen') > -1}
        ],
        account: {
            title: user.name,
            links: navItems([
                options.onClickDetails && {key: 'gegevens', title: t('accountDetails'), icon: 'mdi mdi-account', onClick: options.onClickDetails},
                options.onClickPassword && {key: 'wachtwoord', title: t('changePassword'), icon: 'mdi mdi-lock', onClick: options.onClickPassword},
                {key: 'meldingen', title: t('menuNotifications'), icon: 'mdi mdi-message-outline', target: '/klant/meldingen'},
                accounts.length > 1 && {key: 'wissel', title: t('menuSwitchAccount'), icon: 'mdi mdi-account-multiple', onClick: options.onClickSwitchAccount},
                {key: 'uitloggen', title: t('menuLogout'), icon: 'mdi mdi-logout', onClick: options.onClickLogout}
            ])
        }
    }
}
